import React from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
import TypedText from "../TypedText";

const Prothesiste = () => {
  const navigate = useNavigate();
  return (
    <div className={"prothestsContainer"}>
      <h1>
        {" "}
        Vous êtes : {` `}
        <TypedText
          style={{ color: "#0eaeba" }}
          strings={[
            "Médecin Dentiste",
            `Prothésiste`,
            "Laboratoire de Prothèse dentaire ",
          ]}
        />
      </h1>
      <p>
        Notre Plateforme Tunisienne est desinée pour Vous!{"  "}
        <span>créer Votre Compte Dés maintenant..</span>
      </p>
      <div className={"prothessticSmallContainer"}>
        <div className={"ProthesticCard card1"}>
          <h6>Médecin Dentiste</h6>
          <p>
            Vous pouvez bénéficier des avantages de la pateforme en vous
            inscrivant...
          </p>
          <button onClick={() => navigate("/register?role=dentiste")}>
            S’inscrire
          </button>
        </div>
        <div className={"ProthesticCard card2"}>
          <h6>Laboratoire de Prothèse Dentaire</h6>
          <p>
            Améliorez l'efficacité et la productivité de vos équipes et
            Bénéficier des avantages en vous inscrivant.{" "}
          </p>
          <button onClick={() => navigate("/register?role=laboratoire")}>
            S’inscrire
          </button>
        </div>
      </div>
    </div>
  );
};

export default Prothesiste;
